import {
  buildAdminQueryRoot,
  buildScopedAdminQueryKey,
  type AdminQueryKey,
  type AdminQueryRoot,
  type OrganizationIdInput,
} from '@/lib/organization-scoping'
import type { InventoryIndexQueryKeyEntries } from './inventory.api'

/**
 * Without an organization, the `all` key matches every organization's inventory; the scoped key
 * builders throw without one.
 */
interface OrganizationScope {
  organizationId?: OrganizationIdInput
}

/** The key entries the inventory fetcher reads; the scoped key builder sets them. */
type InventoryIndexQueryKey = [AdminQueryRoot & InventoryIndexQueryKeyEntries]

export const inventoryQueryKeys = {
  all: ({ organizationId }: OrganizationScope = {}): AdminQueryKey => [
    buildAdminQueryRoot({ entity: 'inventory' }, { organizationId }),
  ],
  index: ({ organizationId }: OrganizationScope): InventoryIndexQueryKey =>
    buildScopedAdminQueryKey(inventoryQueryKeys.all({ organizationId })[0], {
      organizationId,
      scope: 'index',
    }),
}
